/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, {forwardRef} from 'react';
import {NavLink as RouterLink} from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/styles/makeStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Button from '@material-ui/core/Button';
import NestedMenu from "../../SubMenu";
import api from '../../../../common/api'
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.palette.white
    },
    item: {
        display: 'flex',
        paddingTop: 0,
        paddingBottom: 0
    },
    button: {
        color: theme.palette.buttonColor.primary,
        padding: '10px 8px',
        justifyContent: 'flex-start',
        textTransform: 'none',
        letterSpacing: 0,
        width: '100%',
        fontSize:'15px',
        fontWeight: theme.typography.fontWeightMedium,
        '&:hover': {
            color: theme.palette.navHover.text
        }
    },
    icon: {
        color: theme.palette.icon,
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        marginRight: theme.spacing(1)
    },
    active: {
        color: theme.palette.navActive,
        fontWeight: theme.typography.fontWeightMedium,
        '& $icon': {
            color: theme.palette.navActive
        }
    }
}));

const CustomRouterLink = forwardRef((props, ref) => (
    <div
        ref={ref}
        style={{flexGrow: 1}}
    >
        <RouterLink {...props} />
    </div>
));

const bookmarkState = {
    id: 0,
    title: "",
    href: "",
    isBookmarked: false
}

const SidebarNav = props => {
    const {pages, open, className, onClose, showMainMenu, ...rest} = props;

    const [errorMessage, setErrorMessage] = React.useState('');
    const [bookmarkDatas, setBookmarkDatas] = React.useState([bookmarkState])

    // Get all bookmark data
    const getAllBookMarks = () => {
        
        const response = api.get("get-all-bookmarks")
        
        response.then(res => {
            console.log("object");
            setBookmarkDatas(res)
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('Bookmarks not found');
            } else {
                setErrorMessage('Unknown Error')
            }
        })
    }

    React.useEffect(getAllBookMarks, [open])

    const classes = useStyles({});

    const generateKey = () => {
        return `${new Date().getTime()}`
    }

    const removeErrorMessage = () =>{
        setErrorMessage('');
    }

    return (
        <div id="error">
    {errorMessage ?
    <Alert severity="error" onClick={removeErrorMessage}>{errorMessage}</Alert>
    : ''}
        <List
            {...rest}
            className={clsx(classes.root, className)}
        >
            {pages.map(page => {
                if (page.nested) {
                    return <NestedMenu getAllBookMarks={getAllBookMarks} bookmarks={bookmarkDatas} {...page} onClose={onClose} key={page.title}/>
                } else {
                    return <ListItem
                        className={classes.item}
                        disableGutters
                        key={page.title+page.href+generateKey()}
                    >
                        <Button
                            activeClassName={classes.active}
                            className={classes.button}
                            component={CustomRouterLink}
                            to={page.href}
                            // onClick={showMainMenu}
                            onClick={onClose}
                            /*onTouchEnd={onClose}*/
                        >
                            <div className={classes.icon}>{page.icon}</div>
                            {page.title}
                        </Button>
                    </ListItem>
                }
            })}
        </List>
        </div>
    );
};

SidebarNav.propTypes = {
    className: PropTypes.string,
    pages: PropTypes.array.isRequired
};

export default SidebarNav;
